import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const JobsTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  { title: 'Status', align: 'start', key: 'status', sortable: false, placeholder: null },
  {
    title: 'Customer',
    align: 'start',
    key: 'clientGUID',
    sortable: false,
    placeholder: 'Customer',
  },
  { title: 'Name', align: 'start', key: 'name', sortable: false, placeholder: 'Project name' },
  { title: 'Number', align: 'start', key: 'number', sortable: false, placeholder: '00000' },
  {
    title: 'Revenue Stream',
    align: 'start',
    key: 'revenueStreamGUID',
    sortable: false,
    placeholder: 'Revenue stream',
  },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
